<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminProgressManagement.vue'
export default {
  name: 'staff-progress-management',
  components: {
    Admin
  }
}
</script>